import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { GoalsSection } from '../components/GoalsSection';
import { TemplatesCarousel } from '../components/TemplatesCarousel';
import { KitContentsSection } from '../components/KitContentsSection';
import { ResultsSection } from '../components/ResultsSection';
import { BeforeAfterSection } from '../components/BeforeAfterSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
export function LandingPage() {
  return <main className="w-full overflow-hidden" data-id="element-227">
      <HeroSection data-id="element-228" />
      <ProblemSection data-id="element-229" />
      <GoalsSection data-id="element-230" />
      <TemplatesCarousel data-id="element-231" />
      <KitContentsSection data-id="element-232" />
      <ResultsSection data-id="element-233" />
      <BeforeAfterSection data-id="element-234" />
      <OfferSection data-id="element-235" />
      <GuaranteeSection data-id="element-236" />
      <FinalCtaSection data-id="element-237" />
    </main>;
}